import { useMutation } from '@tanstack/react-query';
import { api } from '@/api/client';

/**
 * Dépose un fichier de personnalisation (photo de produit, etc.) et renvoie son
 * identifiant de `MediaAsset`. Même motif en trois temps que les autres uploads directs de
 * l'application : demande d'URL présignée, dépôt DIRECT sur le stockage objet, confirmation.
 */
export function useUploadMediaAsset() {
  return useMutation({
    mutationFn: async (file: File): Promise<string> => {
      const { data: ticket } = await api.POST('/api/v1/media/uploads', {
        body: {
          fileName: file.name,
          contentType: file.type,
          kind: 0, // MediaKind.Image
          sizeBytes: file.size,
        },
      });

      if (!ticket) {
        throw new Error("Impossible d'obtenir une URL de téléversement.");
      }

      const uploadResponse = await fetch(ticket.uploadUrl, {
        method: 'PUT',
        headers: ticket.requiredHeaders,
        body: file,
      });

      if (!uploadResponse.ok) {
        throw new Error(`Échec du dépôt du fichier (${uploadResponse.status}).`);
      }

      await api.POST('/api/v1/media/{mediaAssetId}/confirm', {
        params: { path: { mediaAssetId: ticket.mediaAssetId } },
        // @ts-expect-error — le contrat OpenAPI ne déclare pas de corps pour cette route.
        body: {},
      });

      return ticket.mediaAssetId;
    },
  });
}
